import { useAppSelector } from 'app/store';
import { getIsGlobalSearchOpen } from 'app/store/GlobalSearch/selectors';
import { useLocation } from 'react-router-dom';
import { routes } from 'app/routing/routesConfig';

export const useShowGlobalSearch = () => {
  const { pathname } = useLocation();
  const isGlobalSearchOpen = useAppSelector(getIsGlobalSearchOpen);
  const audioLyrics = [
    routes.playerLyrics.path,
    routes.playerPlaylist.path,
  ].includes(pathname);

  return isGlobalSearchOpen && !audioLyrics;
};
